import createReducer from 'lib/createReducer';


export const CREATE_BOOKMARK = 'CREATE_BOOKMARK';
export const DELETE_BOOKMARK = 'DELETE_BOOKMARK';
export const SAVE_BOOKMARKS = 'SAVE_BOOKMARKS';

export const saveBookmarks = bookmarks => {
  return {
    type: SAVE_BOOKMARKS,
    data: bookmarks
  };
};

export const createBookmark = currentCfi => {
  return {
    type: CREATE_BOOKMARK,
    data: currentCfi
  };
};

export const deleteBookmark = bookmarkId => {
  return {
    type: DELETE_BOOKMARK,
    data: bookmarkId
  };
};


const initialState = [];

const actionHandlers = {
  [SAVE_BOOKMARKS]: (state, action) => {
    return [ ...action.data ];
  }
};


export default createReducer(initialState, actionHandlers);
